'use client';

import clsx from 'clsx';

import styles from './styles.module.css';

interface TabItem {
  id: number;
  title: string | null;
}

interface Props<T> {
  tabs: T[];
  value: T | null;
  onChange: (tab: T) => void;
  containerClassName?: string;
  buttonClassName?: string;
}

const TabsNavigation = <T extends TabItem>(props: Props<T>) => {
  const { onChange, value, tabs, buttonClassName, containerClassName } = props;

  return (
    <div className={clsx(styles.container, containerClassName)}>
      {tabs.map((tab) => {
        const isSelected = tab.id === value?.id;

        return (
          <button
            onClick={() => onChange(tab)}
            key={tab.id}
            className={clsx(styles.tab, isSelected && styles.selected, buttonClassName)}
          >
            {tab.title}
          </button>
        );
      })}
    </div>
  );
};

export default TabsNavigation;
